import React from "react";

export const RadioButtonGroup = ({ title, data, selectedValue, setSelectedValue }) => {
    const handleRadioChange = (slug) => {
        setSelectedValue(slug); // Solo se puede seleccionar uno a la vez
    };

    return (
        <div className="mb-3">
            <p className="fs-6 mb-3">{title}</p>
            <div className="d-flex flex-wrap gap-3">
                {data.map(({ slug, value }) => (
                    <div key={slug} className="form-check d-flex align-items-center gap-2">
                        <input
                            className="form-check-input fs-6"
                            type="radio"
                            name={`radio-${title.replace(/\s+/g, "-").toLowerCase()}`}
                            id={`${title}-${slug}`}
                            value={slug} // ✅ Este valor es importante
                            checked={selectedValue === slug}
                            onChange={() => handleRadioChange(slug)}
                        />
                        <label className="form-check-label fw-normal small-text" htmlFor={`${title}-${slug}`}>
                            {value}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};
